module.exports = __webpack_public_path__ + "static/img/manual-13.058c0ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-13.png
// module id = mUio
// module chunks = 4